// 📁 src/dashboard/DashboardHome.jsx
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

// Componente de Card para reutilização
const DashboardCard = ({ title, value, linkTo, linkText }) => (
  <div className="stat-card">
    <h3>{title}</h3>
    <div className="stat-value">{value}</div>
    {linkTo && linkText && (
      <div className="stat-subtext">
        <Link to={linkTo} className="see-details">{linkText}</Link>
      </div>
    )}
  </div>
);

export default function DashboardHome() {
  const intl = useIntl();

  // TODO: Substituir dados mocados por chamadas de API
  const [dashboardData, setDashboardData] = useState({
    username: 'Olivia Wilson',
    totalProperties: '7.061',
    totalLeads: '12.851',
    scoredAssets: '450',
    marketIndex: '1.2%',
    chartData: [
      { name: 'Jan', leads: 40, properties: 24 },
      { name: 'Feb', leads: 30, properties: 13 },
      { name: 'Mar', leads: 20, properties: 98 },
      { name: 'Apr', leads: 27, properties: 39 },
      { name: 'May', leads: 18, properties: 48 },
      { name: 'Jun', leads: 23, properties: 38 },
      { name: 'Jul', leads: 34, properties: 43 },
    ],
  });

  return (
    <div className="dashboard-home">
      <div className="welcome-section">
        <h2>{intl.formatMessage({ id: 'dashboard.welcome' })}, {dashboardData.username}</h2>
        <p>{intl.formatMessage({ id: 'dashboard.subtitle' })}</p>
      </div>

      <div className="stats-cards">
        <DashboardCard
          title={intl.formatMessage({ id: 'dashboard.totalProperties' })}
          value={dashboardData.totalProperties}
          linkTo="/dashboard/properties"
          linkText={intl.formatMessage({ id: 'dashboard.seeAll' })}
        />
        <DashboardCard
          title={intl.formatMessage({ id: 'dashboard.totalLeads' })}
          value={dashboardData.totalLeads}
          linkTo="/dashboard/leads"
          linkText={intl.formatMessage({ id: 'dashboard.seeAll' })}
        />
        <DashboardCard
          title={intl.formatMessage({ id: 'dashboard.scoredAssets' })}
          value={dashboardData.scoredAssets}
          linkTo="/dashboard/analysis"
          linkText={intl.formatMessage({ id: 'dashboard.analyze' })}
        />
        <DashboardCard
          title={intl.formatMessage({ id: 'dashboard.marketIndex' })}
          value={dashboardData.marketIndex}
          linkTo="/dashboard/macro"
          linkText={intl.formatMessage({ id: 'dashboard.seeTrends' })}
        />
      </div>

      <div className="chart-section">
        <h3>{intl.formatMessage({ id: 'dashboard.inquiriesPerMonth' })}</h3>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={dashboardData.chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="properties" fill="#8884d8" name={intl.formatMessage({ id: 'chart.newProperties' })} />
            <Bar dataKey="leads" fill="#82ca9d" name={intl.formatMessage({ id: 'chart.newLeads' })} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}